import api from '../services/api';
import {mapCompanyDto} from "../dto/CompanyDTO";

export const getAllCompanies = async () => {
    try {
        const res = await api.get('/Company');
        return res.data.map(mapCompanyDto);
    } catch (err) {
        console.error("Error receiving company:", err);
        throw err;
    }
};

export const addCompany = async (company) => {
    try {
        const res = await api.post(`/Company`, company);
        return res.data;
    } catch (err) {
        console.error("Error adding company:", err);
        throw err;
    }
};

export const deleteCompany = async (companyId) => {
    try {
        const res = await api.delete(`/Company/${companyId}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting company:", err);
        throw err;
    }
}

export const patchCompany = async (companyId, data) => {
    try {
        const res = await api.patch(`/Company/${companyId}`, data);
        return res.data;
    } catch (err) {
        console.error("Error updating company:", err);
        throw err;
    }
}